import { render, staticRenderFns } from "./PaymentProvidersAPM.vue?vue&type=template&id=64d1c1f0&scoped=true"
import script from "./PaymentProvidersAPM.vue?vue&type=script&lang=js"
export * from "./PaymentProvidersAPM.vue?vue&type=script&lang=js"
import style0 from "./PaymentProvidersAPM.vue?vue&type=style&index=0&id=64d1c1f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d1c1f0",
  null
  
)

export default component.exports